import React from 'react';
import {IModalDialogHandler} from "../../services/dialog/dialog.service.interface";
import {
    GamesGridBox,
    GameViewBox,
    GameViewVerticalDividerBox,
    SubTitleContainerBox,
    GameViewHorizontalDividerBox,
    MenuContainerBox,
    DescriptionContainerBox,
    GameIconContainerBox,
    ButtonWrapperGameViewSectionBox,
    MiddleSeparatorWrapperGameViewSectionBox, GameWrapperGameViewSectionBox
} from "./boxes";
import {GameInfo} from "../../services/games/game-info";

import {Button} from '../../basic-ui-components/button/base/button.component';
import {GameIconBox} from "../../basic-components/game-icon/game-icon.box";

import { SideMenuLinksGroup } from '../side-menu-rework/side-menu-links-group/side-menu-links-group.component';
import {observer} from "mobx-react";
import {OrbitComponentWithState} from "../base-components/orbit-component-with-state/orbit-component-with-state";
import {ICheckboxData} from "../../services/game-popup/game-popup.service.interface";
import {GamePopupCheckboxContainerBox} from "./boxes/game-popup-checkbox-container/game-popup-checkbox-container.box";
import {GamePopupCheckbox} from "./boxes/game-popup-checkbox/game-popup-checkbox.box";

export interface IGamePopupComponentProps {
    subTitle?: string;
    gameInfo?: GameInfo;
    description?: string;
    menuItems?: string[];
    dialogHandler: IModalDialogHandler;
    onClickNotNowButton?: () => void;
    onClickPlay?: () => void;
    checkboxData?: ICheckboxData;
    useSquareIcons?: boolean;
}

interface IGamePopupState {
    checkboxChecked: boolean;
}

/**
 * This component (used for exit-popup, play-game-deep-link-action-base, openAfterLoginGamePopup)
 * may have roughly the same functionality and/or visual
 * as game_item_component_controller (cgp) and game-item.component.tsx (orbit)
 * TODO: Maybe make a common component
 */
@observer
export class GamePopupComponent extends OrbitComponentWithState<IGamePopupComponentProps, IGamePopupState> {
    constructor(props: IGamePopupComponentProps) {
        super(props);
        this.state = {
            checkboxChecked: false
        }
    }

    openRealGame() {
        this.props.dialogHandler.close();
        this.props.gameInfo.open({isRealMode: true});
        this.props.onClickPlay && this.props.onClickPlay();
    };

    clickNotNowButton() {
        this._closeDialog();
        this.props.onClickNotNowButton && this.props.onClickNotNowButton();
    };

    private _closeDialog = () => {
        this.props.dialogHandler.close();
    };

    _getFallbackUrl() {
        // when the square icon load failed (this.props.useSquareIcons is true) then instead of showing a placeholder better to use the
        // more round icon which is more likely not to fail.
        return this.props.useSquareIcons ? this.props.gameInfo.getGameImage({squareIcon: false}) : this.props.gameInfo.getGameImagePlaceHolderUrl();
    }

    getGameView() {
        return (
            <GameViewBox className="game-view-container">

                <GameWrapperGameViewSectionBox>
                    <GameIconContainerBox useSquareIcons={this.props.useSquareIcons}>
                        <GameIconBox
                               src={this.props.gameInfo.getGameImage({squareIcon: this.props.useSquareIcons || false})}
                               fallbackSrc={this._getFallbackUrl()}/>
                    </GameIconContainerBox>

                    <span className="game-title cy-game-popup-game-title">{this.props.gameInfo.title}</span>
                </GameWrapperGameViewSectionBox>

                <MiddleSeparatorWrapperGameViewSectionBox>
                    <GameViewVerticalDividerBox />
                </MiddleSeparatorWrapperGameViewSectionBox>

                <ButtonWrapperGameViewSectionBox>
                    <Button
                        preset="secondary"
                        margin="0px 0px 2rem 0px"
                        fullWidth
                        className={'cy-game-popup-open-real-button'}
                        onClick={this.openRealGame.bind(this)}
                    >
                        {this.services.translation.translate('PLAY')}
                    </Button>

                    <Button
                        preset="flatStroked"
                        fullWidth
                        className={'cy-game-popup-not-now-button'}
                        onClick={this.clickNotNowButton.bind(this)}
                    >
                        {this.services.translation.translate('MAYBE_LATER')}
                    </Button>
                </ButtonWrapperGameViewSectionBox>
            </GameViewBox>
        );
    }

    showCheckboxItem() {
        return(
            <GamePopupCheckboxContainerBox>
                <GamePopupCheckbox className='cy-game-popup-checkbox' checkboxChecked={this.state.checkboxChecked} onClick={()=>
                {
                    this.setState({checkboxChecked: !this.state.checkboxChecked});
                    this.props.checkboxData.onClickHandler();
                }}/>
                <span>{this.services.translation.translate(this.props.checkboxData.text)}</span>
            </GamePopupCheckboxContainerBox>
        );
    }

    getMenuBox() {
        return <MenuContainerBox onClick={this._closeDialog.bind(this)}>
            <SideMenuLinksGroup key={Object.keys(this.props.menuItems).join(',')} menuItemIds={this.props.menuItems} />
        </MenuContainerBox>;
    }

    getSubTitle() {
        return <SubTitleContainerBox>{this.props.subTitle}</SubTitleContainerBox>;
    }

    getDescription() {
        return <DescriptionContainerBox>{this.props.description}</DescriptionContainerBox>;
    }

    getGameSection() {
        if(!this.props.gameInfo)
            return null;
        return (
            <>
                { this.props.subTitle && this.getSubTitle() }
                {this.getGameView()}
            </>
        );
    }

    render() {
        return (
            <GamesGridBox className={'cy-game-popup'}>
                { this.getGameSection() }

                { this.props.menuItems && <GameViewHorizontalDividerBox/> }

                { this.props.description && this.getDescription() }

                { this.props.menuItems && this.getMenuBox() }

                { this.props.checkboxData && this.props.checkboxData.display && this.showCheckboxItem()}

            </GamesGridBox>
        )
    }
}